<template>
    <div class="container">
        <Alert v-bind:onEvent="onAlertEvent" v-if="showAlert"></Alert>
        <Scene1 v-if="1==showScene"></Scene1>
        <Scene2 v-if="2==showScene"></Scene2>
        <Scene3 v-if="3==showScene"></Scene3>
        <Scene4 v-if="4==showScene"></Scene4>
    </div>
</template>

<script>
import Scene1 from '../scene1/Scene1.vue'
import Scene2 from '../scene2/Scene2.vue'
import Scene3 from '../scene3/Scene3.vue'
import Scene4 from '../scene4/Scene4.vue'
import Alert from './Alert.vue'

export default {
    data() {
        return {
            showAlert: true,
            showScene: 0,
        }
    },

    components: {
        Alert,
        Scene1,
        Scene2,
        Scene3,
        Scene4
    },

    methods: {
        onAlertEvent(type) {
            this.showAlert = false
            this.showScene = type
            this.playBgMusic()
        },

        playBgMusic() {
            const audio = new Audio(require('../../assets/audios/bg1.mp3'))
            audio.loop = true
            audio.play()
        }
    }
}
</script>

<style scoped>
.container {
    width: 100%;
    height: 100%;
    color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/director/Director.vue